import { Button, VStack, useDisclosure } from '@chakra-ui/react';
import PageCard from '../../components/page-card';
import { translate } from '../../i18n';
import CreateGameCapacityOptionForm from './components/CreateGameCapacityOptionForm';
import GameCapacityOptionsList from './components/GameCapacityOptionsList';

export default function GameCapacityManagementPage() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <PageCard
        title={translate('game_capacity_options.title')}
        rightHeader={
          <Button
            colorScheme="brand"
            onClick={onOpen}
          >
            {translate('game_capacity_options.add_capacity_option')}
          </Button>
        }
      >
        <VStack spacing={6} align="stretch">
          <GameCapacityOptionsList />
        </VStack>
      </PageCard>

      <CreateGameCapacityOptionForm
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
}

